// extracted by mini-css-extract-plugin
export default {"balanceWrapper":"Balance_balanceWrapper__7Cebl","balanceText":"Balance_balanceText__HuEoK","balance":"Balance_balance__41oSS","balanceSign":"Balance_balanceSign__BjoZ6"};